// extracted by mini-css-extract-plugin
export default {"root":"NewsCard_root__b9jb1","card-body":"NewsCard_card-body__Dpzv8","date":"NewsCard_date__G3PG4","title":"NewsCard_title__XI6om","content":"NewsCard_content__GpKLZ"};